const defaults = {
  color: 'midgray',
  icon: 'check_box',
  next: {
    boolean: 'is',
    date: 'eq',
    indicator: 'eq',
    textual: 'incl',
    numerical: 'eq',
    strict: 'eq',
  },
  symbol: '=',
  text: 'EQ',
  value: 'eq',
}

const custom = {
  color: 'purple',
  icon: 'check_box',
  next: {
    boolean: 'is',
    date: 'eq',
    indicator: 'eq',
    textual: 'incl',
    numerical: 'eq',
    strict: 'eq',
  },
  symbol: '*',
  text: 'CUSTOM',
  value: 'custom',
}

const numerical = [
  {
    color: 'primary',
    icon: 'calculate',
    next: { numerical: 'neq' },
    symbol: '=',
    text: 'EQ',
    value: 'eq',
  },
  {
    color: 'toasted',
    icon: 'calculate',
    next: { numerical: 'lte' },
    symbol: '≠',
    text: 'NEQ',
    value: 'neq',
  },
  {
    color: 'primary',
    icon: 'calculate',
    next: { numerical: 'gte' },
    symbol: '≤',
    text: 'LTE',
    value: 'lte',
  },
  {
    color: 'primary',
    icon: 'calculate',
    next: { numerical: 'eq' },
    symbol: '≥',
    text: 'GTE',
    value: 'gte',
  },
]

const boolean = [
  {
    color: 'primary',
    icon: 'check_box',
    next: { boolean: 'not' },
    symbol: 'is',
    text: 'IS',
    value: 'is',
  },
  {
    color: 'toasted',
    icon: 'indeterminate_check_box',
    next: { boolean: 'is' },
    symbol: 'not',
    text: 'NOT',
    value: 'not',
  },
]

const dateOption = {
  color: 'primary',
  icon: 'calculate',
  next: { date: 'neq' },
  symbol: '=',
  text: 'EQ',
  value: 'eq',
}

const dateRangeOption = {
  color: 'primary',
  icon: 'calculate',
  next: { date: 'eq' },
  symbol: '[]',
  text: 'RANGE',
  value: 'range',
}

const date = [
  dateOption,
  {
    color: 'toasted',
    icon: 'calculate',
    next: { date: 'lte' },
    symbol: '≠',
    text: 'NEQ',
    value: 'neq',
  },
  {
    color: 'primary',
    icon: 'calculate',
    next: { date: 'gte' },
    symbol: '≤',
    text: 'LTE',
    value: 'lte',
  },
  {
    color: 'primary',
    icon: 'calculate',
    next: { date: 'range' },
    symbol: '≥',
    text: 'GTE',
    value: 'gte',
  },
  dateRangeOption,
]

const indicator = [
  {
    color: 'primary',
    icon: 'calculate',
    next: { indicator: 'neq' },
    symbol: '=',
    text: 'EQ',
    value: 'eq',
  },
  {
    color: 'toasted',
    icon: 'calculate',
    next: { indicator: 'lte' },
    symbol: '≠',
    text: 'NEQ',
    value: 'neq',
  },
  {
    color: 'primary',
    icon: 'calculate',
    next: { indicator: 'gte' },
    symbol: '≤',
    text: 'LTE',
    value: 'lte',
  },
  {
    color: 'primary',
    icon: 'calculate',
    next: { indicator: 'eq' },
    symbol: '≥',
    text: 'GTE',
    value: 'gte',
  },
]

const strict = [
  {
    color: 'primary',
    icon: 'check_box',
    next: { strict: 'neq' },
    symbol: 'eq',
    text: 'EQ',
    value: 'eq',
  },
  {
    color: 'toasted',
    icon: 'indeterminate_check_box',
    next: { strict: 'eq' },
    symbol: 'neq',
    text: 'NEQ',
    value: 'neq',
  },
]

const textual = [
  {
    color: 'primary',
    icon: 'check_box',
    next: { boolean: 'excl', textual: 'excl', numerical: 'excl', strict: 'neq' },
    symbol: 'incl',
    text: 'INCL',
    value: 'incl',
  },
  {
    color: 'toasted',
    icon: 'indeterminate_check_box',
    next: { boolean: 'incl', textual: 'incl', numerical: 'incl', strict: 'eq' },
    symbol: 'excl',
    text: 'EXCL',
    value: 'excl',
  },
]

const operators = {
  defaults,
  boolean,
  custom,
  date,
  indicator,
  numerical,
  strict,
  textual,
}

export default operators
export const defaultOperators = defaults.next
export const defaultDateOperator = dateOption.value
export const rangeDateOperator = dateRangeOption.value
